import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../viewsGuarantee/HomeView.vue';
import { useUserStore } from '@/stores/user';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
      // 其他子路由
    ]
  },
  {
    path: '/groupManage',
    name: 'groupManage',
    component: () => import(/* webpackChunkName: "groupManage" */ '../viewsGuarantee/GroupManage.vue'),
    meta: { requiresAuth: true }, // 新的身份验证
    children: [
      {
        path: 'MyGroup',
        name: 'MyGroup',
        component: () => import(/* webpackChunkName: "MyGroup" */ '../viewsGuarantee/MyGroup.vue')
      },
      {
        path: 'StartConfig',
        name: 'StartConfig',
        component: () => import(/* webpackChunkName: "StartConfig" */ '../viewsGuarantee/StartConfig.vue')
      },
      {
        path: 'SelfGroupInfo',
        name: 'SelfGroupInfo',
        component: () => import(/* webpackChunkName: "SelfGroupInfo" */ '../viewsGuarantee/SelfGroupInfo.vue'),
      },
      {
        path: 'KeyWordReplay',
        name: 'KeyWordReplay',
        component: () => import(/* webpackChunkName: "KeyWordReplay" */ '../viewsGuarantee/KeyWordReplay.vue'),
      },
      {
        path: 'JoinGroupWelcome',
        name: 'JoinGroupWelcome',
        component: () => import(/* webpackChunkName: "JoinGroupWelcome" */ '../viewsGuarantee/JoinGroupWelcome.vue'),
      },
      {
        path: 'SettingSelfBot',
        name: 'SettingSelfBot',
        component: () => import(/* webpackChunkName: "SettingSelfBot" */ '../viewsGuarantee/SettingSelfBot.vue'),
      },
    ]
  },
 {
    path: '/Upgrading',
    name: 'Upgrading',
    // component: () => import(/* webpackChunkName: "Upgrading" */ '../viewsShoppingManage/ShoppingManage.vue'),
    meta: { requiresUpgradAuth: true }, 
    children: [
      {
        path: 'UpgradeSuperAdmin',
        name: 'UpgradeSuperAdmin',
        component: () => import(/* webpackChunkName: "UpgradeSuperAdmin" */ '../viewGroupManageUpgradeFushu/UpgradeSuperAdmin.vue')
      },
      {
        path: 'UpgradeWalletPackage',
        name: 'UpgradeWalletPackage',
        component: () => import(/* webpackChunkName: "UpgradeWalletPackage" */ '../viewGroupManageUpgradeFushu/UpgradeWalletPackage.vue')
      },
    ]
  },
  {
    path: '/shoppingManage',
    name: 'shoppingManage',
    component: () => import(/* webpackChunkName: "shoppingManage" */ '../viewsShoppingManage/ShoppingManage.vue'),
    meta: { requiresNewAuth: true },
    children: [
      {
        path: 'MyUser',
        name: 'MyUser',
        component: () => import(/* webpackChunkName: "MyUser" */ '../viewsShoppingManage/MyUser.vue')
      },
      {
        path: 'ShoppingStartConfig',
        name: 'ShoppingStartConfig',
        component: () => import(/* webpackChunkName: "ShoppingStartConfig" */ '../viewsShoppingManage/ShoppingStartConfig.vue')
      },
      {
        path: 'BigCategory',
        name: 'BigCategory',
        component: () => import(/* webpackChunkName: "BigCategory" */ '../viewsShoppingManage/BigCategory.vue')
      },
      {
        path: 'ChildCategory',
        name: 'ChildCategory',
        component: () => import(/* webpackChunkName: "ChildCategory" */ '../viewsShoppingManage/ChildCategory.vue')
      },
      {
        path: 'StoreManage',
        name: 'StoreManage',
        component: () => import(/* webpackChunkName: "StoreManage" */ '../viewsShoppingManage/StoreManage.vue')
      },
      {
        path: 'ConfigEdit',
        name: 'ConfigEdit',
        component: () => import(/* webpackChunkName: "ConfigEdit" */ '../viewsShoppingManage/ConfigEdit.vue')
      },
      {
        path: 'OneClickBroadcast',
        name: 'OneClickBroadcast',
        component: () => import(/* webpackChunkName: "OneClickBroadcast" */ '../viewsShoppingManage/OneClickBroadcast.vue')
      },
    ]
  },
  {
    path: '/GroupHome',
    name: 'GroupHome',
    props: route => ({ groupId: route.query.groupId }),
    component: () => import(/* webpackChunkName: "GroupHome" */ '../viewGroupManageUpgrade/GroupHome.vue'),
  },
  {
    path: '/MangerAllGroup',
    name: 'MangerAllGroup',
    props: route => ({ groupId: route.query.groupId }),
    component: () => import(/* webpackChunkName: "MangerAllGroup" */ '../viewGroupManageUpgrade/MangerAllGroup.vue'),
  },
  {
    path: '/StartConfig',
    name: '/StartConfig',
    props: route => ({ groupId: route.query.groupId }),
    component: () => import(/* webpackChunkName: "StartConfig" */ '../viewGroupManageUpgrade/StartConfig.vue')
  },
  {
    path: '/GroupRemind',
    name: '/GroupRemind',
    component: () => import(/* webpackChunkName: "GroupRemind" */ '../viewGroupManageUpgrade/GroupRemind.vue')
  },
  {
    path: '/SuperAdmin',
    name: 'SuperAdmin',
    props: route => ({ groupId: route.query.groupId }),
    component: () => import(/* webpackChunkName: "SuperAdmin" */ '../viewGroupManageUpgrade/SuperAdmin.vue'),
  },
  {
    path: '/MyBot',
    name: 'MyBot',
    props: route => ({ groupId: route.query.groupId }),
    component: () => import(/* webpackChunkName: "MyBot" */ '../viewGroupManageUpgrade/MyBot.vue'),
  },
  {
    path: '/HelpMe',
    name: 'HelpMe',
    meta: { pageKey: 'help' },
    component: () => import(/* webpackChunkName: "AdPage" */ '../viewGroupManageUpgrade/AdPage.vue'),
  },
  {
    path: '/DevMe',
    name: 'DevMe',
    meta: { pageKey: 'custom_dev' },
    component: () => import(/* webpackChunkName: "AdPage" */ '../viewGroupManageUpgrade/AdPage.vue'),
  },
  {
    path: '/AdPage/:pageKey',
    name: 'AdPage',
    component: () => import(/* webpackChunkName: "AdPage" */ '../viewGroupManageUpgrade/AdPage.vue'),
  },
  {
    path: '/groupManageUpgrade',
    name: 'groupManageUpgrade',
    component: () => import(/* webpackChunkName: "groupManage" */ '../viewGroupManageUpgrade/GroupManage.vue'),
    children: [
      {
        path: 'AdTime',
        name: 'AdTime',
        props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "AdTime" */ '../viewGroupManageUpgrade/AdTime.vue'),
      },
        {
        path: 'ChannelMessage',
        name: 'ChannelMessage',
        props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "ChannelMessage" */ '../viewGroupManageUpgrade/ChannelMessage.vue'),
      },
        {
        path: 'ChannelMessageButton',
        name: 'ChannelMessageButton',
        props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "ChannelMessageButton" */ '../viewGroupManageUpgrade/ChannelMessageButton.vue'),
      },
    {
        path: 'ForwardGroup',
        name: 'ForwardGroup',
        props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "ForwardGroup" */ '../viewGroupManageUpgrade/ForwardGroup.vue'),
      },
        {
        path: 'MsgStatNone',
        name: 'MsgStatNone',
        props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "MsgStatNone" */ '../viewGroupManageUpgrade/MsgStatNone.vue'),
      },
      {
        path: 'DataView',
        name: 'DataView', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "DataView" */ '../viewGroupManageUpgrade/DataView.vue')
      },
      {
        path: 'GroupHeader',
        name: 'GroupHeader',
        props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "GroupHeader" */ '../viewGroupManageUpgrade/GroupHeader.vue'),
      },
      {
        path: 'JoinGroupWelcome',
        name: 'JoinGroupWelcome', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "JoinGroupWelcome" */ '../viewGroupManageUpgrade/JoinGroupWelcome.vue'),
      },
      {
        path: 'JoinGroupValid',
        name: 'JoinGroupValid', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "JoinGroupValid" */ '../viewGroupManageUpgrade/JoinGroupValid.vue'),
      },
      {
        path: 'GroupLeaveSetting',
        name: 'GroupLeaveSetting', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "GroupLeaveSetting" */ '../viewGroupManageUpgrade/GroupLeaveSetting.vue'),
      },
      {
        path: 'TrashManage',
        name: 'TrashManage',
        props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "TrashManage" */ '../viewGroupManageUpgrade/TrashManage.vue'),
      },
      {
        path: 'TrashWhite',
        name: 'TrashWhite',
        props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "TrashWhite" */ '../viewGroupManageUpgrade/TrashWhite.vue'),
      },
      {
        path: 'KeyWordReplay',
        name: 'KeyWordReplay', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "KeyWordReplay" */ '../viewGroupManageUpgrade/KeyWordReplay.vue'),
      },
      {
        path: 'CircleManage',
        name: 'CircleManage', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "CircleManage" */ '../viewGroupManageUpgrade/CircleManage.vue'),
      },
      {
        path: 'CircleSetting',
        name: 'CircleSetting', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "CircleSetting" */ '../viewGroupManageUpgrade/CircleSetting.vue'),
      },
      {
        path: 'CloseGroup',
        name: 'CloseGroup', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "CloseGroup" */ '../viewGroupManageUpgrade/CloseGroup.vue'),
      },
      {
        path: 'CloseChat',
        name: 'CloseChat', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "CloseChat" */ '../viewGroupManageUpgrade/CloseChat.vue'),
      },
      {
        path: 'InviteRace',
        name: 'InviteRace', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "InviteRace" */ '../viewGroupManageUpgrade/InviteRace.vue'),
      },
      {
        path: 'SubscribeChannel',
        name: 'SubscribeChannel', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "SubscribeChannel" */ '../viewGroupManageUpgrade/SubscribeChannel.vue'),
      },
      {
        path: 'MsgStatSetting',
        name: 'MsgStatSetting', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "MsgStatSetting" */ '../viewGroupManageUpgrade/MsgStatSetting.vue'),
      },
      {
        path: 'MsgStatSettingList',
        name: 'MsgStatSettingList', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "MsgStatSettingList" */ '../viewGroupManageUpgrade/MsgStatSettingList.vue'),
      },
      {
        path: 'MsgStatSettingReply',
        name: 'MsgStatSettingReply', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "MsgStatSettingReply" */ '../viewGroupManageUpgrade/MsgStatSettingReply.vue'),
      },
      {
        path: 'PointLog',
        name: 'PointLog', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "PointLog" */ '../viewGroupManageUpgrade/PointLog.vue'),
      },
      {
        path: 'PointRank',
        name: 'PointRank', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "PointRank" */ '../viewGroupManageUpgrade/PointRank.vue'),
      },
      {
        path: 'PointRule',
        name: 'PointRule', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "PointRule" */ '../viewGroupManageUpgrade/PointRule.vue'),
      },
      {
        path: 'PointSetting',
        name: 'PointSetting', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "PointSetting" */ '../viewGroupManageUpgrade/PointSetting.vue'),
      },
      {
        path: 'ChatNum',
        name: 'ChatNum', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "ChatNum" */ '../viewGroupManageUpgrade/ChatNum.vue'),
      },
      {
        path: 'ChatRank',
        name: 'ChatRank', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "ChatRank" */ '../viewGroupManageUpgrade/ChatRank.vue'),
      },
      {
        path: 'LotteryInstant',
        name: 'LotteryInstant', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "LotteryInstant" */ '../viewGroupManageUpgrade/LotteryInstant.vue'),
      },
      {
        path: 'LotteryTime',
        name: 'LotteryTime', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "LotteryTime" */ '../viewGroupManageUpgrade/LotteryTime.vue'),
      },
      {
        path: 'RedeemSetting',
        name: 'RedeemSetting', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "RedeemSetting" */ '../viewGroupManageUpgrade/RedeemSetting.vue'),
      },
      {
        path: 'RedeemGoods',
        name: 'RedeemGoods', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "RedeemGoods" */ '../viewGroupManageUpgrade/RedeemGoods.vue'),
      },
      {
        path: 'RedeemLog',
        name: 'RedeemLog', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "RedeemLog" */ '../viewGroupManageUpgrade/RedeemLog.vue'),
      },
      {
        path: 'GameSetting',
        name: 'GameSetting', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "GameSetting" */ '../viewGroupManageUpgrade/GameSetting.vue'),
      },
      {
        path: 'GameLog',
        name: 'GameLog', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "GameLog" */ '../viewGroupManageUpgrade/GameLog.vue'),
      },
      {
        path: 'MemberLevel',
        name: 'MemberLevel', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "MemberLevel" */ '../viewGroupManageUpgrade/MemberLevel.vue'),
      },
      {
        path: 'MemberList',
        name: 'MemberList', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "MemberList" */ '../viewGroupManageUpgrade/MemberList.vue'),
      },
      {
        path: 'UserChange',
        name: 'UserChange', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "UserChange" */ '../viewGroupManageUpgrade/UserChange.vue'),
      },
      {
        path: 'UserAuth',
        name: 'UserAuth', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "UserAuth" */ '../viewGroupManageUpgrade/UserAuth.vue'),
      },
      {
        path: 'BotLog',
        name: 'BotLog', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "BotLog" */ '../viewGroupManageUpgrade/BotLog.vue'),
      },
      {
        path: 'AutoUsdt',
        name: 'AutoUsdt', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "AutoUsdt" */ '../viewGroupManageUpgrade/AutoUsdt.vue'),
      },
      {
        path: 'GroupBottom',
        name: 'GroupBottom', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "GroupBottom" */ '../viewGroupManageUpgrade/GroupBottom.vue'),
      },
      {
        path: 'OtherSetting',
        name: 'OtherSetting', props: route => ({ groupId: route.query.groupId }),
        component: () => import(/* webpackChunkName: "OtherSetting" */ '../viewGroupManageUpgrade/OtherSetting.vue'),
      },
    ]
  },
  {
    path: '/groupRegister',
    name: 'groupRegister',
    component: () => import(/* webpackChunkName: "groupRegister" */ '../viewsGuarantee/GroupRegisterView.vue')
  },
  {
    path: '/guaranteeLogin',
    name: 'guaranteeLogin',
    component: () => import(/* webpackChunkName: "guaranteeLogin" */ '../viewsGuarantee/GroupManageLogin.vue')
  },
  {
    path: '/shoppingManageRegister',
    name: 'shoppingManageRegister',
    component: () => import(/* webpackChunkName: "shoppingManageRegister" */ '../viewsShoppingManage/ShoppingRegisterView.vue')
  },
  {
    path: '/shoppingManageLogin',
    name: 'shoppingManageLogin',
    component: () => import(/* webpackChunkName: "shoppingManageLogin" */ '../viewsShoppingManage/ShoppingManageLogin.vue')
  },
   {
    path: '/UpgradeLogin',
    name: 'UpgradeLogin',
    component: () => import(/* webpackChunkName: "UpgradeLogin" */ '../viewGroupManageUpgradeFushu/UpgradeLogin.vue')
  },
   {
    path: '/UpgradeRegister',
    name: 'UpgradeRegister',
    component: () => import(/* webpackChunkName: "UpgradeRegister" */ '../viewGroupManageUpgradeFushu/UpgradeRegister.vue')
  },
  {
    path: '/groupManageLogin',
    name: 'groupManageLogin', props: route => ({ codeSn: route.query.codeSn }),
    component: () => import(/* webpackChunkName: "shoppingManageLogin" */ '../viewGroupManageUpgrade/GroupManageLogin.vue')
  },
  {
    path: '/RechargeRecords',
    name: 'RechargeRecords',
    component: () => import(/* webpackChunkName: "RechargeRecords" */ '../viewsShoppingManage/RechargeRecords.vue')
  },
  {
    path: '/OrderRecords',
    name: 'OrderRecords',
    component: () => import(/* webpackChunkName: "OrderRecords" */ '../viewsShoppingManage/OrderRecords.vue')
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});


router.beforeEach((to, from, next) => {
  const userStore = useUserStore();
  // console.log(to.meta.requiresAuth, userStore.isLoggedIn);
  if (to.meta.requiresAuth && !userStore.isLoggedIn) {
    // 如果目标路由需要认证且用户未登录，则重定向到登录页面
    next('/guaranteeLogin');
  } else if (to.meta.requiresNewAuth && !userStore.isShoppingManageLoggedIn) {
    // 如果目标路由需要新的认证且用户未登录，则重定向到新的登录页面
    next('/shoppingManageLogin');
  } else if (to.meta.requiresGroupAuth && !userStore.isGroupManageLoggedIn) {
    // 如果目标路由需要新的认证且用户未登录，则重定向到新的登录页面
    next('/groupManageLogin');
  } else if (to.meta.requiresUpgradAuth && !userStore.isUpgradeLoggedIn) {
    // 如果目标路由需要新的认证且用户未登录，则重定向到新的登录页面
    next('/UpgradeLogin');
  }
  

  else {
    next();
  }
});
export default router;